// Search modal (command palette): Ctrl/Cmd+K toggles, input focused when shown.
export function initSearch() {
	const modalEl = document.getElementById('searchModal');
	if (!modalEl || !window.bootstrap) return;

	const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);

	// Ctrl/Cmd+K opens (and toggles) the search
	document.addEventListener('keydown', (e) => {
		if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
			e.preventDefault();
			modal.toggle();
		}
	});

	// Focus the input once the modal is visible
	modalEl.addEventListener('shown.bs.modal', () => {
		const input = document.getElementById('searchModalInput');
		if (input) input.focus();
	});
}
